import { UnstyledButton } from '@shared/ui/unstyled-button';
import { useAuth } from '@features/auth';
import { EVENT_PAGE_TABS } from '@entities/event';
// Вкладка «Клиенты» на главной странице
// import { Clients } from '@widgets/clients';
import { Events } from '@features/events';
import styles from './events.module.scss';
import { useState } from 'react';
import clsx from 'clsx';

export const EventsPage = () => {
  const {
    data: { groupName },
  } = useAuth();
  const [tab, setTab] = useState(EVENT_PAGE_TABS.events);
  const isEventsTab = tab === EVENT_PAGE_TABS.events;

  return (
    <div className={styles.container} data-testid="events-main-container">
      <div className={styles.content}>
        <div className={styles.tabs}>
          <UnstyledButton onClick={() => setTab(EVENT_PAGE_TABS.events)}>
            <div className={clsx(styles.tab, isEventsTab && styles.tabActive)}>Мероприятия</div>
          </UnstyledButton>

          {/* Вкладка «Клиенты» на главной странице */}
          {/* {isSminexClubGroup && (
            <UnstyledButton onClick={() => setTab(EVENT_PAGE_TABS.clients)}>
              <div className={clsx(styles.tab, !isEventsTab && styles.tabActive)}>Клиенты</div>
            </UnstyledButton>
          )} */}
        </div>

        {/* Вкладки «Клиенты» на главной странице */}
        {/* {isEventsTab ? <Events isSminexClubGroup={isSminexClubGroup} /> : <Clients />} */}
        <Events groupName={groupName} />
      </div>
    </div>
  );
};
